import PubSub from 'pubsub-js';

import '../components/header/local-menu';
import '../components/header/localize';
import '../components/header/header';

class Main {
    onDOMContentLoaded = () => {
        PubSub.publish('init');
    };
}
  
const main = new Main();
window.addEventListener('DOMContentLoaded', main.onDOMContentLoaded);

const resize = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    PubSub.publish('resize');
}

let lastScroll = 0;
const scroll = () => {
    const scrollTop = $(window).scrollTop();
    let scrollDirection = null;
    if (scrollTop < lastScroll) {
        scrollDirection = 'up';
    } else if (scrollTop > lastScroll) {
        scrollDirection = 'down';
    } else {
        scrollDirection = 'stay';
    }
    PubSub.publish('scroll', {scrollDirection, scrollTop});
    lastScroll = scrollTop;
}

$(window).on('resize', () => {
    resize();
});

$(window).on('scroll', () => {
    scroll();
});

resize();
// scroll();